<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .user-cell {
    display: flex;
    align-items: center;
    gap: utils.in_rem(12px);
  }

  .user-info {
    display: flex;
    flex-direction: column;
    h4 {
      display: flex;
      gap: utils.in_rem(6px);
    }
  }

  .user-email {
    color: colors.get(textLighterBlack);
  }

  .user-cell-container {
    display: flex;
    align-items: center;
    gap: utils.in_rem(12px);
  }

  .checkbox-container {
    margin-right: utils.in_rem(4px);
  }
</style>

<script>
  import Avatar from "@sourcewhale/shared/svelte-design-system/components/atoms/Avatar.svelte";
  import MultiCheckbox from "@sourcewhale/shared/svelte-design-system/components/atoms/Checkbox/MultiCheckbox.svelte";
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import StatusTag from "@sourcewhale/shared/svelte-design-system/components/atoms/TagsAndChips/StatusTag.svelte";

  let { user, skeleton = false } = $props();

  let danger = $derived(
    user.originalLicenses.outreach && !user.licenses.outreach
  );

  let deactivated = $derived.by(() => {
    const hadLicenses = Object.values(user.originalLicenses).some(Boolean);
    const hasNoLicenses = !Object.values(user.licenses).some(Boolean);
    return hadLicenses && hasNoLicenses;
  });

  let email = $derived(skeleton ? "Loading..." : user?.email || "");
  let name = $derived(skeleton ? "Loading..." : user?.name || "");
  let firstName = $derived(name.split(" ")[0]);
  let lastName = $derived(
    name
      .split(" ")
      .filter((_, i) => i > 0)
      .join(" ")
  );
  let src = $derived(user?.photo);
</script>

<div class="user-cell-container">
  <div class="checkbox-container">
    <MultiCheckbox />
  </div>
  <div class="user-cell">
    <Avatar size="medium" {skeleton} {src} {firstName} {lastName} />
    <div class="user-info">
      <h4 class:skeleton>
        {name}
        {#if deactivated}
          <StatusTag kind="neutral" size="small">Deactivated</StatusTag>
        {/if}
        {#if danger}
          <Icon
            class="fa-solid fa-exclamation-circle color-systemError_100"
            size="small"
          />
        {/if}
      </h4>
      <div class="user-email" class:skeleton>{email}</div>
    </div>
  </div>
</div>
